<template>
  <form ref="form" :class="{ 'loading-opacity': preloader }">
    <app-modal
      :modal-id="modalId"
      :title="title"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
      modal-size="large"
      modal-alignment="top"
    >
      <template slot="header">
        <h5 class="modal-title">{{ title }}</h5>
        <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span>
            <app-icon :name="'x'"></app-icon>
          </span>
        </button>
      </template>

      <template slot="body">
        <label for="">Busqueda por organización o por código:</label> <br />
        <app-input
          type="text"
          placeholder="Buscador...."
          v-model="buscador"
          @input="search"
        />

        <hr />

        <app-overlay-loader v-if="preloader" />
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th class="align-middle">Organización</th>
              <th class="align-middle">Código</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in evaluations" :key="key">
              <td class="align-middle">
                {{ value.name }}
              </td>
              <td class="align-middle">
                {{ value.code }}
              </td>

            </tr>
          </tbody>
        </table>
      </template>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
        >
          Cerrar
        </button>
      </template>
    </app-modal>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../../apiUrl";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    codeSelected: String,
    selectedUrl: String,
    accApp: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      evaluations: [],
      modalId: "code-eval-modal",
      buscador: "",
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
    this.loadData();
  },
  methods: {
    submit() {
      // console.log(this.inputs);
      // this.save(this.inputs);
    },
    loadData() {
      // load all data evaluation_testification
      const url = `allEvaluationTestification`;
      this.axiosGet(`${actions.ACCREDITATIONS_QUOTATIONS}/${url}/${this.accApp}`)
        .then((response) => {
          this.evaluations = response.data;
        })
        .catch(({ error }) => {});
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      // this.inputs = response.data;
      this.preloader = false;
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    search() {
      console.log("Buscando....");
      if (this.buscador.length > 0) {
        this.axiosPost({
          url: `${actions.ACCREDITATIONS_QUOTATIONS}/foundEvalTestification?buscador=${this.buscador}&accApp=${this.accApp}`,
          q: this.buscador,
        })
          .then((res) => {
            if (res.data.length > 0) {
              this.evaluations = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.loadData();
      }
    },
    selectCode(evalId) {
      console.log(this.data);
      let url = `${actions.ACCREDITATIONS_QUOTATIONS}/selectCode/${evalId}`;
      this.axiosGet(url).then((response) => {
        console.log(response);
        this.closeModal();
      });
    },
  },
};
</script>
